<template>
  <qrcode-stream
    @decode="onDecode"
    @init="onInit"
    v-if="!destroyed"
    class="camera-qr"
  >
    <div class="loading-indicator" v-if="loading">
      <v-progress-circular indeterminate color="red"></v-progress-circular>
    </div>
  </qrcode-stream>
</template>

<script>
import { notify } from '@/common/index.js';
import {
  QRSCAN_COMPANY_CHECKIN_ACTION,
  LANG_CODE_VIETNAMESE,
  ERROR_QRCODE_COMPANY_MESSAGE_VI,
  ERROR_QRCODE_COMPANY_MESSAGE_JP_EN,
  ERROR_QRCODE_RECEPTIONIST_MESSAGE_JP_EN,
  ERROR_QRCODE_RECEPTIONIST_MESSAGE_VI
} from '@/common/constants';

export default {
  name: 'QRCodeScan',
  props: {
    type: String,
    formatOfData: Array
  },
  data: () => ({
    result: '',
    error: '',
    destroyed: false,
    loading: false
  }),
  methods: {
    isCorrectDataFormat(data) {
      for (const type of this.formatOfData) {
        if (!data[type]) {
          return false;
        }
      }
      return true;
    },
    checkResult(result) {
      try {
        const data = JSON.parse(result);
        return this.isCorrectDataFormat(data);
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    async onDecode(result = {}) {
      if (this.checkResult(result)) {
        const dataParse = JSON.parse(result);

        if (dataParse) {
          const data = await this.$store.dispatch(this.type, dataParse);

          if (data) {
            this.$emit('onDecode', data);
          }

          setTimeout(() => {
            this.reload();
          }, 2000);
        }
      } else {
        if (this.type === QRSCAN_COMPANY_CHECKIN_ACTION) {
          if (this.$i18n.locale === LANG_CODE_VIETNAMESE) {
            notify('error', 'Message', ERROR_QRCODE_COMPANY_MESSAGE_VI);
          } else {
            notify('error', 'Message', ERROR_QRCODE_COMPANY_MESSAGE_JP_EN);
          }
        } else {
          if (this.$i18n.locale === LANG_CODE_VIETNAMESE) {
            notify('error', 'Message', ERROR_QRCODE_RECEPTIONIST_MESSAGE_VI);
          } else {
            notify('error', 'Message', ERROR_QRCODE_RECEPTIONIST_MESSAGE_JP_EN);
          }
        }
        setTimeout(() => {
          this.reload();
        }, 2000);
      }
    },

    async onInit(promise) {
      this.loading = true;

      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson';
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser';
        }
      } finally {
        this.loading = false;
      }
    },

    async reload() {
      this.destroyed = true;

      await this.$nextTick();

      this.destroyed = false;
      console.log('reload camera');
    }
  }
};
</script>

<style lang="scss" scoped>
.camera-qr {
  height: 250px !important;
  width: 250px !important;
}

.loading-indicator {
  font-weight: bold;
  font-size: 2rem;
  text-align: center;
}
</style>
